module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-text-window-reverse-d815b15f.svg";